import {
  ADD_AWARD_NOMINATION_REQUEST,
  ADD_AWARD_NOMINATION_SUCCESS,
  ADD_AWARD_NOMINATION_FAILURE,
  ADD_AWARD_NOMINATION_RESET,
} from "../../../types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const addAwardNominationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_AWARD_NOMINATION_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case ADD_AWARD_NOMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case ADD_AWARD_NOMINATION_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.error,
        success: false,
      }

    case ADD_AWARD_NOMINATION_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default addAwardNominationReducer
